<template>
        <Modal class="send-flower-modal"
                v-model="modalFade"
                width='1000'
                @on-visible-change="onVisibleChange">
            <div slot="header" >
                <div class="modal-header">{{modalTitle}}</div>
            </div>
            <div class="content-wrap">
                <div class="left-wrap">
                    <div class="title">{{title}}</div>
                    <ul class="img-list" >
                        <li class="img-item" @click="selectImg(index,item)" :class="{active:selectedImgIndex==index}" v-for="(item,index) in imgList" :key="index">
                            <img class="img" :src="item.image" alt="">
                            <div class="select-icon unSelected" v-if="selectedImgIndex !=index"></div>
                            <div class="select-icon selected" v-else>
                                <i class="inner-circle"></i>
                            </div>
                            <div class="img-title">{{item.title}}</div>
                        </li>
                    </ul>
                </div>

                <div class="form-wrap">
                    <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80">
                        <FormItem label="祭扫人" prop="title">
                            <Input v-model="formValidate.title" placeholder="请输入祭扫人名字"></Input>
                        </FormItem>
                        <FormItem label="关系" prop="relation">
                            <Select v-model="formValidate.relation" placeholder="请选择">
                                <Option :value="item.name" :key="index" v-for="(item,index) in relations">{{item.name}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem label="祭语" prop="content" height="400">
                            <Input v-model="formValidate.content" type="textarea" :autosize="{minRows: 2,maxRows: 5}" ></Input>
                        </FormItem>
                        <!--<FormItem label="验证码" prop="code">-->
                            <!--<Input v-model="formValidate.code" placeholder="请输入验证码"></Input>-->
                        <!--</FormItem>-->
                        <FormItem>
                            <Button style="width: 100px;" size="large" type="primary" @click="handleSubmit('formValidate')">提交</Button>
                            <Button style="width: 100px;margin-left: 8px" size="large" @click="handleReset('formValidate')" >重写</Button>
                        </FormItem>
                    </Form>
                </div>
            </div>
            <div slot="footer"></div>
        </Modal>
</template>

<script>
    import api from '../../../api/api'
    import storage from '../../../stroage'
    import {mapState} from 'vuex'
    var self;
    export default {
        props:{
            fade:{
                type:Boolean,
                default:false
            },
            type:{
                type:String
            },
        },
        components: {

        },
        data(){
            return{
                selectedImgIndex:-1,
                selectedArticleId:'',
                modalFade:false,
                imgList:[],
                // musicList:[],
                relations:[],//关系人
                selectMusic:'',
                formValidate: {
                    title: '',
                    relation:'',
                    content:''
                },
                ruleValidate: {
                    title: [
                        { required: true, message: '请输入祭扫人名字', trigger: 'blur' }
                    ],
                    relation: [
                        { required: true, message: '请选择您和逝者关系', trigger: 'change' }
                    ],
                    content: [
                        { required: true, message: '留几句祭语吧', trigger: 'blur' },
                        { type: 'string', min: 10, message: '最少10个字哦！', trigger: 'blur' }
                    ]
                }
            }
        },
        computed:{
            ...mapState(['currentMemorialId']),
            modalTitle(){
                var title = ''
                switch (this.type) {
                    case 'flower':title = '献花' ;break;
                    case 'wine':title = '祭酒' ;break;
                    case 'music':title = '点歌' ;break;
                    default: title = '标题'
                }
                return title
            },
            title(){
                var title = ''
                switch (this.type) {
                    case 'flower':title = '请选择的献花' ;break;
                    case 'wine':title = '请选择祭酒' ;break;
                    case 'music':title = '请选择点歌' ;break;
                }
                return title
            }
        },
        watch:{
            fade(data){
                this.modalFade = data
                if(data){
                    this.initModalData()
                    this.getMemorialArticleList()
                }
            }
        },
        activated(){
            self = this;
            this.getRelations()
        },
        methods:{
            //初始化页面数据
            initModalData(){
                this.formValidate= {
                    title: '',
                    relation:'',
                    content:''
                };
                this.selectedImgIndex=-1;
                this.selectedArticleId='';
                this.imgList=[];
            },
            //获取关系列表
            getRelations(){
                storage.getRelations().then(res =>{
                    self.relations = res;
                })
            },
            onVisibleChange(flag){
                if(!flag){
                    this.$emit('closeModal')
                }
            },
            selectImg(index,item){
                this.selectedImgIndex = index;
                this.selectedArticleId = item.articleId

            },
            //获取祭品列表
            getMemorialArticleList(){
                api.getMemorialArticleList(this.type).then(res =>{
                    self.imgList = res
                })
            },
            handleSubmit (name) {
                var selectedArticleId = this.selectedArticleId
                console.log('selectedArticleId:,',selectedArticleId)
                if(!selectedArticleId){
                    this.$Message.error('请选择祭品，谢谢！')
                    return
                }
                var data = {
                    memorialId:this.currentMemorialId,
                    type:this.type,
                    articleId:selectedArticleId
                }
                this.$refs[name].validate((valid) => {
                    if (valid) {
                        var opt = Object.assign({},data,self[name]);
                        console.log('保存祭品参数：',opt)
                        api.addMemorial(opt).then(res =>{
                            self.$Message.success('保存成功');
                            setTimeout(function () {
                                self.$emit('submitSuccess')
                            },500)

                        }).catch(error =>{
                            this.$Message.error(error.info);
                        })
                    } else {
                        this.$Message.error('请查看数据是否正确!');
                    }
                })
            },
            handleReset (name) {
                this.$refs[name].resetFields();
            }
        }
    }
</script>

<style scoped lang="scss">

    .modal-header{
        font-size: 20px;
        text-align: center;
    }
    .content-wrap{
        overflow: hidden;
        .left-wrap{
            float: left;
            width: 510px;
            .title{
                padding: 20px 0;
                font-size: 16px;
            }
            .img-list{
                overflow: hidden;
                .img-item{
                    float: left;
                    margin-right: 20px;
                    margin-bottom: 20px;
                    position: relative;
                    .img{
                        width: 150px;
                        height: 150px;
                    }
                    .select-icon {
                        width: 13px;
                        height: 13px;
                        position: absolute;
                        border-radius: 15px;
                        &.unSelected{
                            border: 2px solid #666;
                            top: 5px;
                            right: 5px;
                        }
                        &.selected{
                            border: 2px solid #009DE9;
                            top: 5px;
                            right: 5px;
                            border-radius: 15px;
                            .inner-circle{
                                width: 5px;
                                height: 5px;
                                position: absolute;
                                display: inline-block;
                                background-color: #009DE9;
                                top: 2.3px;
                                left: 2.3px;
                                border-radius: 15px;
                            }
                        }
                    }
                    .img-title{
                        text-align: center;
                        font-size: 14px;
                    }
                    &.active{
                        box-shadow:2px 2px 5px #969696;
                        .img-title{
                            color: #009DE9 ;
                        }
                    }
                }
            }
            .music-list{
                padding-left: 30px;
                .music-item{
                    width: 45%;
                    padding: 10px 0;
                }
            }
        }
        .form-wrap{
            float: left;
            width: 400px;
            padding-top: 60px;
        }
    }


</style>
